$(document).bind('mobileinit', () => {
    $.extend($.mobile, {
        autoInitializePage: false
    });
});

$(document).ready(() => {

    // Function para conocer el width del window cuando ocurre el evento resize
    const getWidthWindow = () => {
        let width = $(window).width();
        $(window).resize(() => {
            width = $(window).width();
            return width;
        });

        return width;
    }

    // Config img event
    $(document).on('dragstart', 'img', function (evt) {
        evt.preventDefault();
    });

    // Event Swipe

    const content_cards = $('.cards-s');

    $.each(content_cards, function () {

        const break_w = 1080;

        $(this).children('.cards-s__wrap').animate({
            opacity: 1
        }, 1000);

        $(this).on('swipeleft', function () {

            const width = getWidthWindow();

            if (width < break_w) {
                $(this).children('.cards-s__wrap').animate({
                    left: '-50px',
                }, 700);
                $(this).children('.cards-s__wrap').animate({
                    left: '0px',
                }, 200);
                $(this).children('.cards-s__wrap:first-child').appendTo($(this));
            }

        });

        $(this).on('swiperight', function () {

            const width = getWidthWindow();

            if (width < break_w) {
                $(this).children('.cards-s__wrap').animate({
                    left: '50px',
                }, 700);
                $(this).children('.cards-s__wrap').animate({
                    left: '0px',
                }, 200);
                $(this).children('.cards-s__wrap:last-child').prependTo($(this))
            }

        });

    });

    // Modal details

    const modal__details = $('.card-s-modal-details');

    $.each(modal__details, function () {

		$(this).hide();

        const modal_close = $(this).children('.card-s-modal-details__box').children('.modal-close');
        const categories = $(this).children('.card-s-modal-details__box').children('.modal-categories').children('.modal-categories__category');

        $.each(modal_close, function () {

            $(this).click(function () {

                const modal = $(this).parent('.card-s-modal-details__box').parent('.card-s-modal-details');
                modal.removeClass('active');
                modal.children('.card-s-modal-details__box').removeClass('active');
                setTimeout(() => {
                    modal.hide();
                }, 500);

            });

        });

        $.each(categories, function () {

            $(this).click(function () {

                const category = $(this).next('.modal-categories__category-details');
                const icon = $(this).children('.c-icon');

				(icon.hasClass('active')) ? icon.removeClass('active') : icon.addClass('active');

                category.slideToggle(500);

            });

        });

    })

    // Modal Hover

    const cards_modals = $('.card-s-modal');
    $.each(cards_modals, function () {
        cards_modals.hide();
    });

    const cards_slide = $('.card-s');
    $.each(cards_slide, function () {

        const break_w = 1080;
        const modal = $(this).siblings('.card-s-modal');
        const arrow = modal.children('.card-s-modal__quote').children('.quote-arrow');
        const bgr = $(this).siblings('.card-s-bgr');
        const sub_modal = $(this).siblings('.card-s-modal-details');

        $(this).mouseenter(function () {

            const width = getWidthWindow();

            if (width >= break_w) {

                modal.show();
                modal.addClass('active');

                modal.mouseleave(function () {
                    $(this).removeClass('active');
                    setTimeout(() => {
                        $(this).hide();
                    }, 300);
                });

                arrow.click(function () {
                    sub_modal.show();
                    sub_modal.children('.card-s-modal-details__box').addClass('active');
                });

            }

		});

        $(this).click(function () {

			const width = getWidthWindow();

			if (width < break_w) {

				// modal.show();
                // modal.addClass('active');

                // modal.click(function () {
                //     $(this).removeClass('active');
                //     setTimeout(() => {
                //         $(this).hide();
                //     }, 300);
                // });

                // arrow.click(function () {
                sub_modal.show();
                sub_modal.children('.card-s-modal-details__box').addClass('active');
                sub_modal.addClass('active');
                // });

			}

		});

    });


});
